import type { FontFaceSpec } from '../../types';
import woff2 from '../src/PPMori-SemiBoldNew.woff2';
import woff from '../src/PPMori-SemiBoldNew.woff';

export const ppMoriSemiBold: FontFaceSpec = {
  weight: 600,
  style: 'normal',
  src: [
    { file: woff2, format: 'woff2' },
    { file: woff, format: 'woff' },
  ],
};
